import { render, staticRenderFns } from "./InputLabel.vue?vue&type=template&id=6ca2e432&"
import script from "./InputLabel.vue?vue&type=script&lang=js&"
export * from "./InputLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports